import React, { useEffect } from "react";
import { useLanguage } from "../i18n/LanguageContext";
import { educationsData } from "../data/educationsData";
import { certificatesData } from "../data/certificatesData";
import EducationItem from "../components/EducationItem";
import "../components/css/education.css";

export default function Education() {
  const { t, localize } = useLanguage();
  useEffect(() => {
    document
      .querySelector('meta[name="keywords"]')
      ?.setAttribute(
        "content",
        "software engineer, Kuwait, education, certificates, Computer Engineering, AUM, CODED, IBM Data Analyst, McKinsey Forward, ArcSight, Next.js",
      );
  }, []);
  // Identify the bootcamp by its stable translation key, before localization.
  const isBootcamp = (item) =>
    item.title === "certificates.fresh_grad_bootcamp.title";
  const chapters = [
    {
      id: "formal-education",
      heading: "learning.education",
      entries: educationsData,
      degree: true,
    },
    {
      id: "bootcamp",
      heading: "learning.bootcamp",
      entries: certificatesData.filter(isBootcamp),
    },
    {
      id: "certificates-courses",
      heading: "learning.certificates",
      entries: certificatesData.filter((item) => !isBootcamp(item)),
    },
  ];
  return (
    <div id="education" className="education learning-editorial">
      <header className="learning-intro">
        <h1>
          {t("learning.heading")
            .split(/(&)/)
            .map((part, index) =>
              part === "&" ? (
                <span className="learning-title-accent" key={index}>
                  {part}
                </span>
              ) : (
                part
              ),
            )}
          <span className="learning-title-accent" aria-hidden="true">
            .
          </span>
        </h1>
      </header>
      {chapters.map((chapter) => (
        <section
          className="learning-chapter"
          aria-labelledby={chapter.id}
          key={chapter.id}
        >
          <h2 id={chapter.id}>{t(chapter.heading)}</h2>
          {localize(chapter.entries).map((item) => (
            <EducationItem
              key={item.jobTitle || item.title}
              education={item}
              degree={chapter.degree}
            />
          ))}
        </section>
      ))}
    </div>
  );
}
